import Model from './Model'

export default class Ncr extends Model
{
    getFormAttributes() {
        const attributes = this.getAttributes()
        attributes.package = { label: this.package_name, value: this.package_id }
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes.package = attributes.package?.value
        return attributes
    }

    static async all (packageId = null) {
        const params = { package: packageId }
        const { data } = await Http.get(route('api.v1.ncrs.index'), { params })
        return this.make(data)
    }

    static async allOpened () {
        const params = { open: true }
        const { data } = await Http.get(route('api.v1.ncrs.index'), { params })
        return this.make(data)
    }

    static async allWithActivity (filters = {}) {
        const params = { has_activity: true, from: filters?.from, to: filters?.to }
        const { data } = await Http.get(route('api.v1.ncrs.index'), { params })
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.ncrs.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.ncrs.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.ncrs.destroy', this.id))
    }

    async copyToDefect () {
        await Http.put(route('api.v1.ncrs.copy-to-defect', this.id))
    }
}
